import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { RawXmlResponse } from '../../../../interfaces/response/AdminPageResponses';

/**
 * An adapter converts raw XML data HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class RawXmlDataAdapter implements Adapter<string> {

  /**
   * Converts raw XML data HTTP response to {@link string}.
   * @param item raw XML data HTTP response.
   */
  adapt(item: RawXmlResponse): string {
    return item.xmlData;
  }
}
